import { useCallback, useEffect, useState } from "react";

const useLocalStorage = (
    key: string,
    defaultValue: string | null = null,
    depsArr: unknown[] = [],
): [string | null, (value: string) => void] => {
    if (defaultValue !== null) {
        localStorage.setItem(key, defaultValue);
    }

    const [internalValue, setInternalValue] = useState(localStorage.getItem(key));

    useEffect(() => {
        setInternalValue(localStorage.getItem(key));
    }, [key, ...depsArr]);

    const setCallback = useCallback(
        (value: string) => {
            localStorage.setItem(key, value);
            setInternalValue(localStorage.getItem(key));
        },
        [key],
    );

    return [internalValue, setCallback];
};

export default useLocalStorage;
